import { createAsyncThunk } from '@reduxjs/toolkit'
import { ProjectModel } from 'model/ProjectModel'
import { projectAPIBuilder } from '../asyncActions/BoMAsyncActions'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const saveProjectBatchSize = createAsyncThunk<any, any, { state: any }>(
  'project/saveProjectBatchSize',
  async (batchSize: number, thunkAPI) => {
    const { projectId, api } = projectAPIBuilder(thunkAPI.getState)

    thunkAPI.dispatch(
      newProjectActions.setActiveProjectProperties({
        financial: { quantity: parseInt(batchSize.toString()) },
      } as Partial<ProjectModel>)
    )

    thunkAPI.dispatch(newProjectActions.resetBomItemFinancials([projectId]))

    try {
      return await api.SetProjectBatchSize(projectId, batchSize)
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
